<template>
  <div class="scenarios">
    <div class="accordion">
      <div class="slide slide--civilian" :class="{'slide--expanded': civilianExpanded}">
        <div class="bgImage bgImage--civilian"></div>
        <div class="slide__content" :class="{'slide__content--expanded': civilianExpanded}">
          <h1><span class="highlight">Civilian:</span><br>Metro</h1>
          <p>Our cities face increased threats from terrorist attacks, improvised explosive CBRN threats, and accidents, such as chemical or biological factory fires or explosions.</p>
          <p>In these scenarios, we explore some of the potential threats.</p>
          <TransitionPage>
            <Button class="scenarioButtons" v-if="civilianExpanded == false" btnContent="Choose civilian threat" iconType="plus" @click="buttonClick"/>
            <div v-if="civilianExpanded" class="buttonWrapper scenarioButtons">  
              <Button btnContent="Chemical" @click="$router.push('scenarios/civilian-chemical/intro')"/>
              <Button btnContent="Biological" @click="$router.push('scenarios/civilian-biological/intro')"/>
              <Button btnContent="Radiological" @click="$router.push('scenarios/civilian-radiological/intro')"/>
            </div>
          </TransitionPage>
        </div>
      </div>
      <div class="slide slide--military" :class="{'slide--contracted': civilianExpanded}">
        <div class="bgImage bgImage--military"></div>
        <div class="slide__content">
          <h1><span class="highlight">Military:</span><br>Battlefield</h1>
          <p>A generation ago, the type of CBRN threat seen in war was very different from the ones we face today – and although the risk of large-scale nuclear war has decreased significantly, the potential to experience chemical, biological or radiological warfare is still a real one.</p>
          <p>In this scenario, we follow the advanced reporting system that means soldiers can detect and contain a potential enemy gas risk before it can disrupt their supply route.</p>
          <Button class="scenarioButtons" btnContent="Start military scenario" iconType="arrow" @click="$router.push('scenarios/military/intro')"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TransitionPage from "@/transitions/TransitionPage";
import TitleBlock from '@/components/TitleBlock';
import Button from '@/components/Button';

export default {
  name: 'scenarios',
  components: {
    TransitionPage,
    Button,
    TitleBlock
  },
  data() {
    return {
      civilianExpanded: false
    }
  },
  methods: {
    buttonClick: function() {
      this.civilianExpanded = ! this.civilianExpanded;
    }
  }
}
</script>


<style lang="scss" scoped>
  .highlight {
    color: $colour__accent1;
  }
  .accordion {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    left: 0;
  }

  .slide {
    flex-grow: 1;
    flex-shrink: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    transition: all 0.5s;
    position: relative;
    background-color: $colour__primary1;

    &--expanded {
      width: 70%;
    }

    &--contracted {
      width: 30%;
    }

    &__content {
      width: 25vw;
      margin: 0 auto;
      transition: all 0.5s;
      position: relative;
      color: $white;

      &--expanded {
        width: 80%;
      }
    }
  }

  .buttonWrapper .button {
    margin-right: 0.5em;
  }

  .scenarioButtons {
    position: absolute;
  }

  h1 {
    margin-bottom: 0.25em;
  }

  p {
    max-width: 25vw;
    &:last-of-type {
      margin-bottom: 5em;
    }
  }

  .bgImage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    filter: blur(5px);

    &--civilian {
      background-image: url('../../public/images/civilian.jpg');      
    }

    &--military {
      background-image: url('../../public/images/military.jpg');
    }
  }
</style>

